import {
  Box,
  Divider,
  Flex,
  Stack,
  useColorModeValue,
  Image,
  VStack,
} from "@chakra-ui/react";
import {
  FiHome,
  FiSettings,
  FiUsers,
  FiAtSign,
  FiLayers,
  FiLayout,
  FiDollarSign,
} from "react-icons/fi";
import { useNavigate, useLocation } from "react-router-dom";
import { NavButton } from "./NavButton";
import { UserProfile } from "./UserProfile";
import { KYDOrganizationUser } from "@common/interfaces/KYDUser";
import { KYDScope } from "@common/interfaces/ICognito";

const sidebarItems = [
  {
    label: "Overview",
    route: "/dashboard",
    icon: FiHome,
    condition: (scopes: KYDScope[]) =>
      scopes.includes("organizations/overview:read") ||
      scopes.includes("organizations/write"),
  },
  {
    label: "Events",
    route: "/events",
    icon: FiLayout,
  },
  {
    label: "Bundles",
    route: "/bundles",
    icon: FiLayers,
  },
  {
    label: "Team",
    route: "/team",
    icon: FiUsers,
    condition: (scopes: KYDScope[]) =>
      scopes.includes("organizations/write") ||
      scopes.includes("organizations/users:read") ||
      scopes.includes("organizations/users:write"),
  },
  {
    label: "Bio",
    route: "/bio",
    icon: FiAtSign,
  },
  {
    label: "Payouts",
    route: "/payouts",
    icon: FiDollarSign,
    condition: (scopes: KYDScope[]) =>
      scopes.includes("organizations/write") ||
      scopes.includes("organizations/payouts:write") ||
      scopes.includes("organizations/payouts:read"),
  },
  {
    label: "Settings",
    route: "/settings",
    icon: FiSettings,
    condition: (scopes: KYDScope[]) => scopes.includes("organizations/write"),
  },
];

export const Sidebar = ({
  currentUser,
  onOrganizationClick,
  scopes = [],
}: {
  currentUser: KYDOrganizationUser | null;
  onOrganizationClick: () => void;
  scopes: KYDScope[];
}) => {
  const location = useLocation();

  return (
    <Flex as="section" minH="100vh" bg="bg-canvas" zIndex="999">
      <Flex
        flex="1"
        bg="bg-surface"
        overflowY="auto"
        boxShadow={useColorModeValue("md", "sm-dark")}
        maxW={{ base: "full", sm: "250px" }}
        py={{ base: "2", sm: "4" }}
        px={{ base: "4", sm: "6" }}
      >
        <Stack justify="space-between" spacing="1">
          <Stack spacing={{ base: "5", sm: "6" }} shouldWrapChildren>
            <VStack>
              <Image
                maxW="50%"
                src="https://content.kydlabs.com/system/logoblack.png"
              />
              <Divider />
            </VStack>
            <Stack spacing="1">
              {sidebarItems
                .filter((item) => !item.condition || item.condition(scopes))
                .map((item) => (
                  <NavButton
                    key={item.route}
                    isSelected={location.pathname === item.route}
                    route={item.route}
                    label={item.label}
                    icon={item.icon}
                    bg={location.pathname === item.route ? "black" : undefined}
                    color={
                      location.pathname === item.route ? "white" : undefined
                    }
                  />
                ))}
            </Stack>
          </Stack>
          <Stack spacing={{ base: "5", sm: "6" }}>
            <Divider />
            {currentUser && (
              <UserProfile
                currentUser={currentUser}
                onOrganizationClick={onOrganizationClick}
              />
            )}
          </Stack>
        </Stack>
      </Flex>
    </Flex>
  );
};
